<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps"  ref="SetBtn"></buttonlist>
		<el-tabs @tab-click="tabclick" v-model="SelectIndexs">
			<el-tab-pane :label="$t('getapi[13255]')" name="0" id="xpane-0">
                <div style="display:none">
                    <input type="file" id="file2" @change="filePdfChange()" multiple accept=".pdf" />
                </div>
                <div>
                    <table style="border-spacing: 3px">
                        <tr>
                            <td class="myCell">
                                <el-button type="primary" size="mini" :disabled="!btn.delete" @click="BatchDelFaReport()">{{$t('getapi[7241]')}}</el-button>
                            </td>
                            <td class="myCell">
                                <el-button size="mini" type="success" @click="btnClick1('文件')" plain icon="el-icon-document-copy" title="2.选择PDF文件">{{$t('getapi[6507]')}}</el-button>
                            </td>
                            <td class="myCell">
                                <el-button size="mini" type="success" @click="btnClick1('上传')" plain icon="el-icon-upload" title="3.上传文件">{{$t('getapi[7814]')}}</el-button>
                            </td>   
                            <td class="myCell"></td>  
                            <td class="myCell"></td>  
                            <td class="myCell"></td>  
                            <td class="myCell"></td>  
                            <td class="myCell"></td>  
                        </tr>
                        <tr>
                            <td colspan="8">
                                <div v-if="search1.info">
                                    <el-progress :text-inside="true" :stroke-width="15" :percentage="search1.percentage" status="success"> </el-progress>
                                </div>
                            </td>
                        </tr>
                    </table>  
                </div>               
                <wTable
						:data="dataSet"
						:loading="loading"
						:header="tableHeader"
						queryData="ProNewOrderReportRequirements"
						@handleSelectionChange="handleSelectionChange"
						:option="tableOption"
						ref="singleTable"></wTable>
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[13256]')" name="1" id="xpane-1">
                <div>
                    <table style="border-spacing: 3px">
                        <tr>
                            <td class="myCell">
                                <el-button type="primary" :disabled="!btn.ruupload"  size="mini" @click="ReUpload()">{{$t('getapi[13259]')}}</el-button>
                            </td>
                        </tr>
                    </table> 
                    
                </div>
				<wTable
						:data="dataSet1"
						:loading="loading"
						:header="tableHeader1"
						queryData="ProNewOrderReportRequirements"
						@handleSelectionChange="handleSelectionChange1"
                        @cellclick="openPdfView"
						:option="tableOption"
						ref="singleTable1"></wTable>
			</el-tab-pane>
		</el-tabs>
			<el-row v-if="SelectIndexs == 0" class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<el-row v-if="SelectIndexs == 1" class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange1"
						@current-change="handleCurrentChange1"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize1"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total1"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="ProNewOrderReportRequirements" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[1030]')" queryData="ProNewOrderReportRequirements" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'fareportview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
            dataSet1: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('fareportview'), // 当前页数据量
			SelectIndexs: '0', //当前页面
			total: 0, // 数据总量
            pageIndex1: 1, // 当前页
            pageSize1: this.$http.getPageSize('fareportview1'), // 当前页数据量
            total1: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
            tableHeader1: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectData: [],
            selectData1: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//重新上传
				ruupload: false,
				//删除
				delete: false,
			},
            isEditVisible: false,//行编辑弹窗
            rowDetail:{},//行明细
            scrollTop:0,
            scrollTop1:0,
            search1: {
                info: null, percentage: 1
            },
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndexs)
            })
        },
        dataSet1: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndexs)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
		let lastmonth = new Date().getMonth() ;
		let thismonth = new Date().getMonth() + 1;
		let myyear = new Date().getFullYear();
		if (lastmonth < 10) {
		lastmonth = '0' + lastmonth;
		}
		if (thismonth < 10) {
		thismonth = '0' + thismonth;
		}
		that.copyparam.startMonth = myyear+"-"+lastmonth;
		that.copyparam.copyMonth = myyear+"-"+thismonth;
	},
    // activated () {
    //     let that = this
    //     setTimeout(() => {
    //         that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
    //             that.scrollTop = res.target.scrollTop
    //         },false)
    //         that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
    //             that.scrollTop1 = res.target.scrollTop
    //         },false)
    //     }, 5000);
    //     // 路由跳转回来滚动到离开时的位置
    //     this.$nextTick(()=> {
    //         setTimeout(() => {
    //             this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
    //             this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
    //         }, 13)
    //     })
    // },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('ProNewOrderReportRequirements',0,PFileds=>{
                if(that.SelectIndexs==0){
                    that.tableHeader=PFileds;
                }
                else if(that.SelectIndexs==1){
                    that.tableHeader1=PFileds;
                }
			});
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8213]"),this.$t("getapi[3846]"));
        },
        btnClick1(f) {
            let doc;
            if (f == "文件") {
                doc = document.getElementById('file2');
                if (doc) {
                    doc.click();
                }
            }else if (f == "上传") {
                this.search1.percentage = 1;
                this.uploadTempToServer(0, this.dataSet);
            }
            else {
                return;
            }
        },
        filePdfChange() {
            let that = this;
            that.search1.info = null;
            let doc = document.getElementById('file2');
            if (!doc) {
                return;
            }
            let fileRows = doc.files;
            if (fileRows == null) {
                return null;
            }
            if (fileRows.length == 0) {
                return null;
            }
            let gridRows = that.dataSet;
            if (gridRows == null || gridRows.length == 0) {
                that.$message.error(that.$t('getapi[11812]'));//'缺少清单列表，不能选择上传文件。'
                that.fileClear();
                return;
            }

            let nOK = 0;
            let i = 0;
            let j = 0;
            for (i = 0; i < gridRows.length; i++) {
                for (j = 0; j < fileRows.length; j++) {
                    // 名称相同
                    if (gridRows[i].fa_filename.toLowerCase() == fileRows[j].name.toLowerCase()) {
                        gridRows[i].status = '待上传';
                        gridRows[i].remark = that.fnFileSize(fileRows[j].size);

                        gridRows[i].fa_filename2 = fileRows[j].name.toLowerCase();
                        gridRows[i].file = fileRows[j];
                        nOK = nOK + 1;
                        break;
                    }
                }
            }
            console.log(gridRows)
            let nOKTotal = 0;
            for (i = 0; i < gridRows.length; i++) {
            if (gridRows[i].fa_filename2) {
                nOKTotal = nOKTotal + 1;
            }
            }
            that.fileClear();

            if (nOKTotal == gridRows.length) {
            let msg = that.$t('getapi[11813]')+"<br/>"+that.$t('getapi[11814]')+"：<sapn class='text-red'>" + nOKTotal + '<span>'+that.$t('getapi[11753]');
            //请确认，是否自动上传文件?/总匹配/个文件
            that.$confirm(msg, that.$t('getapi[194]'), {
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning',
                dangerouslyUseHTMLString: true
            })
                .then(() => {
                var t = setTimeout(
                    function () {
                    that.search1.percentage = 1;
                    that.uploadTempToServer(0, gridRows);
                    }
                    , 100);
                })
                .catch(action => {
                that.fileClear();
                });
            }
            else {
            that.search1.info = that.$t('getapi[201]') + gridRows.length + that.$t('getapi[11753]')+','+that.$t('getapi[11814]') + nOKTotal + that.$t('getapi[11753]');
            //共/个文件/总匹配/个文件
            }
        },        
        uploadTempToServer(index, rows) {
            // 上传PDF文件
            let that = this;
            if (index < 0 || rows == null) {
                that.search1.percentage = 100;
                that.fileClear();
                return;
            }
            this.search1.info = (index + 1) + '/' + rows.length;
            if (index >= rows.length) {
                that.search1.percentage = 100;
                for (let xx = 0; xx < rows.length; xx++) {
                    if (rows[xx].status != '生成') {
                        that.search1.info = "";
                        that.$message.warning(that.$t('getapi[13258]'));//文件名匹配成功已上传完成,未完成的请检查文件名与清单中文件名是否一致,谢谢！
                        break;
                    }
                    rows[xx].file = null;
                }
                that.fileClear();
                that.getView();
                return;
            }

            that.search1.percentage = parseInt(Math.round(100 * (index + 1) / parseFloat(rows.length)));

            let doc = rows[index];
            if (that.fnToNull(doc.fa_filename2) == null) {
                doc.remark = '未匹配文件';
            } else if (doc.file == null) {
                doc.remark = '未选择文件';
            }
            else {
                doc.status = "上传中";
            }
            if (doc.status != '上传中') {
                // 下一条
                that.uploadTempToServer(index + 1, rows);
                return;
            }
            // 上传清单
            var formData = new FormData();
            formData.append("fa_filename", doc.fa_filename);
            formData.append("so_code", doc.so_code);            
            formData.append("file", doc.file);
            formData.append("Token", JSON.parse(that.userData).token);
            formData.append("LangType", that.$processdata.getLang());
                that.$http.urlpost('Pur/FaReport/FaReportUploadFiles', formData, function (res) {
                if (res.Success == 1) {
                    doc.status = "已上传";
                    doc.file = null;
                    doc.fa_filename2 = null;
                } else if (res.Success == 100) {
                    doc.status = "已上传";
                    doc.file = null;
                    doc.fa_filename2 = null;
                    // 清理
                    that.uploadTempToServer(-1, rows);

                    that.$message.success(that.$t('getapi[13257]'));//'文件已上传,请刷新！'
                    that.getView();
                    return;
                }
                else {
                    doc.status = "重新上传";
                    doc.remark = res.Msg;
                }
                // 下一笔
                that.uploadTempToServer(index + 1, rows);
            });
        },     
        fileClear() {
            let doc = document.getElementById('file2');
            if (doc) {
                doc.value = null;
            }
            // this.search1.info = null;
        },
        fnFileSize(size) {
            let unitArr = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
            let index = 0;
            let quotient = parseFloat(size);
            while (quotient > 1024) {
            if (index >= unitArr.length) {
                break;
            }
            index += 1;
            quotient = quotient / 1024;
            }
            if (index === 0) {
            return quotient + ' ' + unitArr[index];
            } else {
            return quotient.toFixed(2) + ' ' + unitArr[index];
            }
        },
        fnToNull(obj) {
            if (obj === null || obj === "") {
            return null;
            }
            if (typeof (obj) === undefined || typeof (obj) == "undefined") {
            return null;
            }
            return obj;
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');              
            
		},
		btnauthority() {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
            that.selectData = []
            for (let i = 0; i < val.length; i++) {
                that.selectData.push(val[i]);
            }
            if(that.selectData.length>0){
                //删除
                that.btn.delete=true
            }
            else{
                 //删除
                 that.btn.delete=false
            }
			that.authority()
		},
        handleSelectionChange1(val) {
            let that = this;
            that.selectData1 = []
            for (let i = 0; i < val.length; i++) {
                that.selectData1.push(val[i]);
            }
            if(that.selectData1.length>0){
                //重新上传
                that.btn.ruupload=true
            }
            else{
                 //重新上传
                 that.btn.ruupload=false
            }
				
            that.authority()
        },
        ReUpload(){
            let that = this
            this.$confirm(that.$t('getapi[13260]'), that.$t('getapi[194]'), {//'确定要清除上传状态吗？?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {                    
                    if(that.selectData1.length > 0){
                        let arr = [];
                        for (let i = 0; i < that.selectData1.length; i++) {
                            arr = [
                                ...arr,
                                {
                                    exclusively_id: that.selectData1[i].exclusively_id,
                                }
                            ];
                        }
                        let parm = {
                            Lists: arr
                        };
                        that.$http.urlpost('/Pur/FaReport/BatchReUpload', parm, function (res) {
                            if (res.Success == 1) {
                                that.getView();
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
        },
        BatchDelFaReport(){
            let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {                    
                    if(that.selectData.length > 0){
                        let arr = [];
                        for (let i = 0; i < that.selectData.length; i++) {
                            arr = [
                                ...arr,
                                {
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                            ];
                        }
                        let parm = {
                            Lists: arr
                        };
                        that.$http.urlpost('/Pur/FaReport/BatchDelFaReport', parm, function (res) {
                            if (res.Success == 1) {
                                that.getView();
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
        },
        openPdfView(row,column,cell,event) {
            let that=this;
            if(column.property=='fa_filename'){
                if (that.$limits.fnIsEmpty(row.file_path)) {
                    return;
                }                
                if(row.file_path.toLowerCase().includes('.pdf')){            
                    let href = row.file_path.replace(/\\/g, "/");
                    that.pdfurl =Common.InUrl+'/fafile/'+href;
                    window.open(that.pdfurl,"_blank");
                }
            }
        },
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('fareportview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
        handleSizeChange1(val) {
            this.pageSize1 = val;
            this.$http.savePageSize('fareportview1',val)
            this.getView();
            this.authority();
        },
        handleCurrentChange1(val) {
            this.pageIndex1 = val;
            this.getView();
            this.authority();
        },
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'ProNewOrderReportRequirements');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
            that.getView();
		},
        tabclick(tab){
            let that = this;
            console.log(tab.name)
            that.SelectIndexs =tab.name;
            that.$nextTick(function(){
                that.$processdata.initForm(tab.name)
            });
            that.colsort();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac,
                SelectIndex:that.SelectIndexs,
			};
			if(that.SelectIndexs == 0){
                that.$http.urlpost('/Pur/FaReport/FaReportDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.authority();
                });
			} else if(that.SelectIndexs == 1){
                that.$http.urlpost('/Pur/FaReport/FaReportDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet1 = res.DataContent;
                        that.total1 = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.authority();
                });
			}
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "ProNewOrderReportRequirements",
                fromname: that.$t('getapi[13246]'),
                SelectIndexs: that.SelectIndexs,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},  
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
